// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_1ioBdv_a_P4tisn44e5vYh","title":"zAOV1FwDVZd9ZZzuyS56","message":"_2Bf5OlCZsMuUuHm_GkJauH","cta":"_1GrWZtjMeMws25iMnZBwQa","supportLink":"_1qT7VrDE4lOBZwzlYpv-AY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HardPaywallModal/TrialExpiredAdmin/TrialExpiredAdmin.css
// module id = 527
// module chunks = 0